/** Copia negli appunti. `navigator.clipboard` vuole un contesto sicuro (https o
 *  localhost): fuori da lì si ripiega sul vecchio `execCommand`, così il
 *  pulsante non resta muto. */
export async function copia(testo: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(testo);
    return true;
  } catch {
    const area = document.createElement("textarea");
    area.value = testo;
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand("copy");
    area.remove();
    return ok;
  }
}
